<template>
    <div>
        <van-cell-group>
            <van-cell title="优惠券" :value="data.deduction_amount"/>
            <van-cell title="账户/现金" :value="data.rev_account_name + '/' + data.rev_amount" />
            <van-cell title="储值卡" :value="data.storedvaluecard_amount" />
        </van-cell-group>
    </div>
</template>

<script>
import {
  CellGroup,
  Cell
} from 'vant';

export default {
  name: 'amt',
  props: ['data'],
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell
  },
  data() {
    return {};
  },
  mounted() {
    console.log(this.$router)
    // this.getData()
  }
};
</script>